import { render } from "./message.html?vue&type=template&id=4dfb08fe&scoped=true&ts=true"
import script from "./message.ts?vue&type=script&lang=ts"
export * from "./message.ts?vue&type=script&lang=ts"

import "./message.scss?vue&type=style&index=0&id=4dfb08fe&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfb08fe"]])

export default __exports__